<template>
  <transition name="fade" mode="out-in">
    <div class="dashboard-container">
      <div class="dashboard-header">
        <slot name="dashboard-header"></slot>
      </div>
      <div class="dashboard-body">
        <slot name="dashboard-body"></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  //
}
</script>
